/**
 * @generated SignedSource<<996fe9fc347f4bab3029f9aace1bd71a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SessionStatus = "ACTIVE" | "DEBRIEFED" | "DEBRIEFING" | "ENDED" | "FAILED" | "%future added value";
export type AccountHistoryQuery$variables = {
  language: string;
};
export type AccountHistoryQuery$data = {
  readonly me: {
    readonly learner: {
      readonly defaultCharacter: {
        readonly audience: string;
        readonly displayName: string;
      } | null | undefined;
      readonly familyWeek: {
        readonly reads: ReadonlyArray<{
          readonly book: {
            readonly ask: string | null | undefined;
            readonly cover: string;
            readonly gloss: string | null | undefined;
            readonly id: string;
            readonly title: string;
          };
          readonly finishedAt: any;
        }>;
        readonly sentences: ReadonlyArray<{
          readonly createdAt: any;
          readonly id: string;
          readonly sentence: string | null | undefined;
          readonly turnId: string | null | undefined;
        }>;
        readonly talks: ReadonlyArray<{
          readonly startedAt: any;
          readonly topic: string | null | undefined;
        }>;
      } | null | undefined;
      readonly id: string;
      readonly memories: ReadonlyArray<{
        readonly createdAt: any;
        readonly id: string;
        readonly kind: string;
        readonly text: string;
      }>;
      readonly sessions: {
        readonly nodes: ReadonlyArray<{
          readonly character: {
            readonly displayName: string;
          } | null | undefined;
          readonly id: string;
          readonly startedAt: any;
          readonly status: SessionStatus;
          readonly topic: string | null | undefined;
        }>;
      };
    } | null | undefined;
  } | null | undefined;
};
export type AccountHistoryQuery = {
  response: AccountHistoryQuery$data;
  variables: AccountHistoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "language"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audience",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  },
  {
    "kind": "Literal",
    "name": "spoken",
    "value": true
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "topic",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startedAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "FamilyWeek",
  "kind": "LinkedField",
  "name": "familyWeek",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FamilyTalk",
      "kind": "LinkedField",
      "name": "talks",
      "plural": true,
      "selections": [
        (v7/*:: as any*/),
        (v5/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ScrapbookPage",
      "kind": "LinkedField",
      "name": "sentences",
      "plural": true,
      "selections": [
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sentence",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "turnId",
          "storageKey": null
        },
        (v8/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoryRead",
      "kind": "LinkedField",
      "name": "reads",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "finishedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "StoryBook",
          "kind": "LinkedField",
          "name": "book",
          "plural": false,
          "selections": [
            (v1/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ask",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cover",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "language",
                  "variableName": "language"
                }
              ],
              "kind": "ScalarField",
              "name": "gloss",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "LearnerMemory",
  "kind": "LinkedField",
  "name": "memories",
  "plural": true,
  "selections": [
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    (v8/*:: as any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountHistoryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*:: as any*/),
                "concreteType": "SessionConnection",
                "kind": "LinkedField",
                "name": "sessions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Session",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v1/*:: as any*/),
                      (v5/*:: as any*/),
                      (v6/*:: as any*/),
                      (v7/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Character",
                        "kind": "LinkedField",
                        "name": "character",
                        "plural": false,
                        "selections": [
                          (v3/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "sessions(first:20,spoken:true)"
              },
              (v9/*:: as any*/),
              (v10/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AccountHistoryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  (v3/*:: as any*/),
                  (v1/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*:: as any*/),
                "concreteType": "SessionConnection",
                "kind": "LinkedField",
                "name": "sessions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Session",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v1/*:: as any*/),
                      (v5/*:: as any*/),
                      (v6/*:: as any*/),
                      (v7/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Character",
                        "kind": "LinkedField",
                        "name": "character",
                        "plural": false,
                        "selections": [
                          (v3/*:: as any*/),
                          (v1/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "sessions(first:20,spoken:true)"
              },
              (v9/*:: as any*/),
              (v10/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3a065d6c8550e7785d3e8f2389e53f0f",
    "id": null,
    "metadata": {},
    "name": "AccountHistoryQuery",
    "operationKind": "query",
    "text": "query AccountHistoryQuery(\n  $language: String!\n) {\n  me {\n    learner {\n      id\n      defaultCharacter {\n        audience\n        displayName\n        id\n      }\n      sessions(first: 20, spoken: true) {\n        nodes {\n          id\n          topic\n          status\n          startedAt\n          character {\n            displayName\n            id\n          }\n        }\n      }\n      familyWeek {\n        talks {\n          startedAt\n          topic\n        }\n        sentences {\n          id\n          sentence\n          turnId\n          createdAt\n        }\n        reads {\n          finishedAt\n          book {\n            id\n            title\n            ask\n            cover\n            gloss(language: $language)\n          }\n        }\n      }\n      memories {\n        id\n        kind\n        text\n        createdAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8fbd00c26067c0580c08426384bfa577";

export default node;
